import { render, staticRenderFns } from "./teamHome.vue?vue&type=template&id=3a9f6756&scoped=true&"
import script from "./teamHome.vue?vue&type=script&lang=js&"
export * from "./teamHome.vue?vue&type=script&lang=js&"
import style0 from "./teamHome.vue?vue&type=style&index=0&id=3a9f6756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f6756",
  null
  
)

export default component.exports